import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './components/modules/admin/admin.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { LayoutsModule } from './components/_shared/layouts/layouts.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthenticationModule } from './components/modules/authentication/authentication.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { SpecialistComponent } from './components/modules/specialist/specialist.component';
import { PcvComponent } from './components/modules/pcv/pcv.component';
import { AuthenticationComponent } from './components/modules/authentication/authentication.component';
import { MaterialModule } from './_shared/module/material.module';
import { FormsModule } from '@angular/forms';
import { CustomDirectiveModule } from './core/directives/custom-directive.module';
import { NgxStripeModule } from 'ngx-stripe';
import { TwilioService } from './services/twilio.service';
import { MatCheckboxModule } from '@angular/material/checkbox'; 
import { MatInputModule } from '@angular/material/input';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TermsModule } from './components/modules/terms/terms.module';
import { environment } from '../environments/environment';
import { SharedModalsModule } from './components/_shared/modals/shared-modals.module';
import { SpecialtySharedModule } from './_shared/modules/specialty-shared.module';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    AuthenticationComponent,
    SpecialistComponent,
    PcvComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    LayoutsModule,
    AuthenticationModule,
    HttpClientModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MaterialModule,
    FormsModule,
    CustomDirectiveModule,
    MatCheckboxModule,
    MatInputModule,
    MatIconModule,
    TermsModule,
    NgxStripeModule.forRoot(environment.stripe.publishableKey),
    NgIdleKeepaliveModule.forRoot(),
    SharedModalsModule,
    SpecialtySharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
